import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ContentUpComingEventEntity, ModuleUpComingEvents } from '../../interfaces'

@Component({
  selector: 'dmmp-website-upcoming-events',
  templateUrl: './website-upcoming-events.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebsiteUpcomingEventsComponent {
  @Input() identifier: string
  @Input() module: ModuleUpComingEvents
  @Input() totalPaginator: number
  @Input() currentPaginator: number
  @Output() redirectPage: EventEmitter<void> = new EventEmitter<void>()
  @Input() allUpcomingEvents: ContentUpComingEventEntity[]
  @Output() getMore: EventEmitter<void> = new EventEmitter<void>()

  constructor() { }

}
